'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFourDotsSquare, iconFourDotsSquareTag } from '@ni/nimble-components/dist/esm/icons/four-dots-square';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFourDotsSquare };
export { iconFourDotsSquareTag };
export const NimbleIconFourDotsSquare = wrap(IconFourDotsSquare);